import React from "react";
import { AddTemplateCategorySection } from "./Addtemplatecategorysection";

export const AddTemplateUtilitySection: React.FC = () => (
  <AddTemplateCategorySection category="UTILITY" />
);